import { render, staticRenderFns } from "./521.vue?vue&type=template&id=33c45e09&scoped=true"
import script from "./521.vue?vue&type=script&lang=js"
export * from "./521.vue?vue&type=script&lang=js"
import style0 from "./521.vue?vue&type=style&index=0&id=33c45e09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c45e09",
  null
  
)

export default component.exports